import React, { useState, useEffect } from 'react';
import './App.css';
import MapEditor from './components/MapEditor';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footer from './components/Footer';
import { MapProvider } from './context/MapContext';

// Import i18n initialization
import './i18n';

function App() {
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState({ text: '', type: '' });

  // Show status message
  const showStatus = (text, type = 'info') => {
    setStatusMessage({ text, type });
    // Clear message after 3 seconds
    setTimeout(() => {
      setStatusMessage({ text: '', type: '' });
    }, 3000);
  };

  return (
    <MapProvider>
      <div className="app-container">
        <Header />
        
        <div className="main-container">
          <MapEditor setLoading={setLoading} />
          <Sidebar showStatus={showStatus} />
        </div>
        
        <Footer />
        
        {loading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
          </div>
        )}
        
        {statusMessage.text && (
          <div className={`status-message status-${statusMessage.type}`} style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1001,
            padding: '10px 20px',
            borderRadius: '4px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
          }}>
            {statusMessage.text}
          </div>
        )}
      </div>
    </MapProvider>
  );
}

export default App;
